// extracted by mini-css-extract-plugin
export var editButton = "_oq-0";